import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Croissant, Sun, Utensils, Salad } from 'lucide-react';
const services = [{
  title: 'The Continental',
  description: 'Artisanal pastries, seasonal fruit platter, yogurt parfaits with house-made granola.',
  icon: Croissant
}, {
  title: 'Hot Breakfast',
  description: 'Farm-fresh scrambled eggs, applewood smoked bacon, roasted potatoes, and sourdough toast.',
  icon: Utensils
}, {
  title: 'Morning Wellness',
  description: 'Acai bowls, avocado toast station, cold-pressed juices, and superfood smoothies.',
  icon: Sun
}, {
  title: 'Midday Refresh',
  description: 'Fresh salads, artisan sandwiches, seasonal soups, and house-made dressings.',
  icon: Salad
}, {
  title: 'Coffee Service',
  description: 'Premium local roast coffee, selection of organic teas, and house-made almond milk.',
  icon: Coffee
}];
export function Services() {
  return <section id="services" className="relative py-24 bg-[#F5F1ED] overflow-hidden" data-id="element-114">
      {/* Serene morning visual elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#FFE5B4]/20 to-transparent rounded-full blur-3xl" data-id="element-115" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-[#D4AF37]/10 to-transparent rounded-full blur-3xl" data-id="element-116" />

      <div className="relative max-w-7xl mx-auto px-6" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24 text-center" data-id="element-118">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 rounded-full bg-[#FFE5B4]/20 border border-[#D4AF37]/20" data-id="element-119">
            <Sun className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} data-id="element-120" />
            <span className="text-sm font-medium text-[#2D3748]/70 tracking-wide" data-id="element-121">
              OUR MENU
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2D3748] mb-6" data-id="element-122">
            Curated Menus
          </h2>
          <p className="text-lg text-[#2D3748]/70 max-w-2xl mx-auto" data-id="element-123">
            Simple, wholesome, and delicious options designed to energize your
            team without the heaviness.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-[#fff] p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" data-id="element-125">
              {/* Morning light accent on card */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-[#FFE5B4]/20 to-transparent rounded-tr-2xl rounded-bl-full" data-id="element-126" />

              <div className="relative" data-id="element-127">
                <div className="w-12 h-12 rounded-full bg-[#F5F1ED] flex items-center justify-center mb-6 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-white transition-colors duration-300" data-id="element-128">
                  <service.icon size={24} strokeWidth={1.5} data-id="element-129" />
                </div>
                <h3 className="text-xl font-bold text-[#2D3748] mb-3" data-id="element-130">
                  {service.title}
                </h3>
                <p className="text-[#2D3748]/70 leading-relaxed text-sm" data-id="element-131">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}